// src/App.jsx
import React, { useState, useEffect } from "react";
import StartScreen from "./components/StartScreen";
import Game from "./components/Game";
import GameOnline from "./components/GameOnline";
import GoogleAd from "./components/GoogleAd";
import Footer from "./components/Footer";
import SalaScreen from "./components/SalaScreen";
import SalaOnline from "./components/SalaOnline";
import "./App.css";

import { ref, onValue, set, update } from "firebase/database";
import { db } from "./firebase";

function App() {
  // Firebase realtime test (puedes quitar esto en producción)
  const [mensajeFirebase, setMensajeFirebase] = useState("");
  useEffect(() => {
    set(ref(db, "pruebaConexion"), { mensaje: "Hola mundo" });
  }, []);
  useEffect(() => {
    const mensajeRef = ref(db, "pruebaConexion/mensaje");
    const unsubscribe = onValue(mensajeRef, (snapshot) => {
      const valor = snapshot.val();
      setMensajeFirebase(valor);
    });
    return () => unsubscribe();
  }, []);

  // ESTADOS GENERALES
  const [modo, setModo] = useState(""); // "", "local", "online"
  // LOCAL
  const [jugadores, setJugadores] = useState([]);
  const [dificultad, setDificultad] = useState("");
  const [juegoIniciado, setJuegoIniciado] = useState(false);
  // ONLINE
  const [codigoSala, setCodigoSala] = useState(null);
  const [nombreJugador, setNombreJugador] = useState("");
  const [sala, setSala] = useState(null);
  const [modoOnline, setModoOnline] = useState(false);

  // --- Funciones para modos ---
  // LOCAL
  const iniciarJuego = (listaJugadores, nivel) => {
    setJugadores(listaJugadores);
    setDificultad(nivel);
    setJuegoIniciado(true);
  };
  const volverAlInicio = () => {
    setJugadores([]);
    setDificultad("");
    setJuegoIniciado(false);
    setModo("");
  };

  // ONLINE
  // Entrar en sala (callback para SalaScreen)
  const entrarEnSala = (codigo, nombre) => {
    setCodigoSala(codigo);
    setNombreJugador(nombre);
    setModoOnline(true);
  };
  // Salir de sala
  const salirDeSala = () => {
    setModoOnline(false);
    setCodigoSala(null);
    setNombreJugador("");
    setModo("");
    setSala(null);
  };
  // Firebase listener: cuando estás en una sala online
  useEffect(() => {
    if (!codigoSala) return;
    const salaRef = ref(db, `salas/${codigoSala}`);
    const unsubscribe = onValue(salaRef, snap => {
      setSala(snap.val());
    });
    return () => unsubscribe && unsubscribe();
  }, [codigoSala]);

  // Empezar partida online (solo el creador)
  const handleEmpezarPartida = () => {
    if (!sala || sala.creador !== nombreJugador) return;
    update(ref(db, `salas/${codigoSala}`), {
      estadoJuego: "ruleta",
      turno: 0
    });
  };

  // ¿Estás en la sala y aún no ha comenzado la partida?
  const enLobby = modo === "online" && modoOnline && sala && (!sala.estadoJuego || sala.estadoJuego === "lobby");

  // Cuando empieza partida online, mostrar GameOnline
  const enPartidaOnline = modo === "online" && modoOnline && sala && sala.estadoJuego && sala.estadoJuego !== "lobby";

  return (
    <div className="app-root">
      {/* Puedes quitar la prueba de Firebase cuando quieras */}
      <div style={{
        background: "#e3f7ff", padding: "8px 14px", borderRadius: 10,
        margin: "1.2rem auto", width: "min(350px, 90vw)", textAlign: "center", boxShadow: "0 2px 8px #00e2ff24"
      }}>
        <h4 style={{ margin: 0, color: "#008dc2" }}>Mensaje en tiempo real:</h4>
        <p style={{ margin: 0 }}>{mensajeFirebase}</p>
      </div>
      <header className="header-main">
        <h1 className="logo-titulo">🚦 Carnetados</h1>
      </header>
      <GoogleAd />
      <main>
        {/* MENÚ PRINCIPAL */}
        {modo === "" && (
          <div style={{ textAlign: "center", margin: "2rem auto" }}>
            <button className="btn-menu-modo" style={{ marginRight: 15 }} onClick={() => setModo("local")}>Jugar en este dispositivo</button>
            <button className="btn-menu-modo" onClick={() => setModo("online")}>Jugar online (sala)</button>
          </div>
        )}

        {/* MODO LOCAL */}
        {modo === "local" && !juegoIniciado && (
          <StartScreen onStart={iniciarJuego} />
        )}
        {modo === "local" && juegoIniciado && (
          <Game
            jugadores={jugadores}
            dificultadSeleccionada={dificultad}
            onExit={volverAlInicio}
          />
        )}

        {/* MODO ONLINE */}
        {modo === "online" && !modoOnline && (
          <SalaScreen onEntrarSala={entrarEnSala} />
        )}

        {/* LOBBY ONLINE */}
        {enLobby && (
          <SalaOnline
            sala={sala}
            codigoSala={codigoSala}
            miNombre={nombreJugador}
            jugadores={sala && sala.jugadores ? Object.values(sala.jugadores) : []}
            onSalir={salirDeSala}
            handleEmpezarPartida={handleEmpezarPartida}
          />
        )}
        {/* PARTIDA ONLINE */}
        {enPartidaOnline && (
          <GameOnline
            codigoSala={codigoSala}
            miNombre={nombreJugador}
            sala={sala}
            jugadores={sala && sala.jugadores ? Object.values(sala.jugadores) : []}
            onSalir={salirDeSala}
          />
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
